<div class="row">
    <div class="col-xl-4 col-lg-4">
        <div class="card img">
            <div class="bg-overlay"></div>
            <div class="card-body">
                <div class="row">
                    <div class="col-8">
                        <h4 style="color: white">Technical Support</h4>
                        <p class="text-muted">He lay on his armour-like back, and if he lifted his head.</p>
                    </div>
                    <div class="col-4">
                        <button class="btn btn-primary" style=" margin-top: 31px;"> book now</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
